import { ofType } from '@ngrx/effects';
import { ActionCreator, ReducerTypes, on } from '@ngrx/store';
import { authenticationVerificationFailure, newAppVersionLoaded } from '../app-start/app-start.actions';
import { applicationVersionChangeAcknowledged } from '../app.actions';
import { apiLogoutSuccess, reAuthenticationCancel } from './state/authentication.actions';

/**
 * Returns an On that will reset the state to the given initial state whenever global reset actions are dispatched.
 * This includes actions dispatched when the user logs out, when the application version changes, and when a user's
 * session is found to be invalid.
 * @param initialState The initial state to reset to
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function onReset<S>(initialState: S): ReducerTypes<S, ActionCreator[]> {
   return on(
      apiLogoutSuccess,
      reAuthenticationCancel,
      newAppVersionLoaded,
      authenticationVerificationFailure,
      // we don't need to reset on applicationVersionChangeAcknowledged, since that action triggers a page reload anyway
      () => {
         return initialState as any;
      }
   );
}

/**
 * 'ofReset' filters an observable of actions into an observable of global reset actions.
 * This includes actions dispatched when the user logs out, when the application version
 * has changed, and when a user's session is found to be invalid.
 */
export function ofReset() {
   return ofType(
      apiLogoutSuccess,
      reAuthenticationCancel,
      newAppVersionLoaded,
      authenticationVerificationFailure,
      applicationVersionChangeAcknowledged
   );
}
